export default __webpack_public_path__ + "static/media/share.99a7d929.png";